import * as React from 'react';
import { RouteObject } from 'react-router-dom';

import HomePage from '../pages/home/page';
import DashboardPage from '../pages/dashboard/page';
import DiaryListPage from '../pages/diary/page';
import DiaryDetail from '../pages/diary/components/DiaryDetail';
import MaterialsListPage from '../pages/materials/page';
import VideosListPage from '../pages/videos/page';
import ContactPage from '../pages/contact/page';
import PrivacyPage from '../pages/privacy/page';
import DisclaimerPage from '../pages/disclaimer/page';
import QuizPage from '../pages/quiz/page';
import LoginPage from '../pages/login/page';
import NotFound from '../pages/NotFound';
import PortfolioPage from '../pages/portfolio/page';
import AdminPage from '../pages/admin/page';
import RankingPage from '../pages/ranking/page';
import ProfilePage from '../pages/profile/page';
import GroupsPage from '../pages/groups/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/dashboard',
    element: <DashboardPage />,
  },
  {
    path: '/diary',
    element: <DiaryListPage />,
  },
  {
    path: '/diary/:id',
    element: <DiaryDetail />,
  },
  {
    path: '/materials',
    element: <MaterialsListPage />,
  },
  {
    path: '/videos',
    element: <VideosListPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/disclaimer',
    element: <DisclaimerPage />,
  },
  {
    path: '/quiz',
    element: <QuizPage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/portfolio',
    element: <PortfolioPage />,
  },
  {
    path: '/admin',
    element: <AdminPage />,
  },
  {
    path: '/ranking',
    element: <RankingPage />,
  },
  {
    path: '/groups',
    element: <GroupsPage />,
  },
  {
    path: '/profile',
    element: <ProfilePage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;